<template>
    <div v-if="showBank">
        <div class="main fixed bg_fff t0 b0 flex column oh" style="width:600px;height:600px;">
            <h3 class="color_fff bg_555 fs14 pl15 pr15 pt10 pb10 flex aic flex0" style="cursor: move" v-bank>
                <span class="flex1">视频白板</span>
                <div class="flex0 flex">
                    <span class="el-icon-close fs18 flex0 pointer" @click="hide"></span>
                </div>
            </h3>
            <div style="width: 100%;height: 100%;">
                <div class="tag">
                    <select @change="selectChangeType($event)">
                        <option value=2 >画线</option>
                        <option value=5 >画折线</option>
                        <option value=999 >画箭头</option>
                        <option value=4 >画椭圆</option>
                        <option value=3 >画矩形</option>
                        <option value=333 >填充矩形</option>
                        <option value=11 >画菱形</option>
                        <option value=13 >画对号</option>
                        <option value=12 >画固定箭头</option>
                        <option value=14 >画错号</option>
                        <option value=8 >画名字</option>
                    </select>


                    <select @change="setColorOpacity($event)">
                        <option value=0.1 >0.1</option>
                        <option value=0.3 >0.3</option>
                        <option value=0.5 >0.5</option>
                        <option value=0.7 >0.7</option>
                        <option value=1 >1</option>
                    </select>

                    <select @change="selectChangeColor($event)">
                        <option value="rgba(0,0,0,1)">黑色</option>
                        <option value="rgba(255,255,255,1)">白色</option>
                        <option value="rgba(255,0,0,1)">红色</option>
                        <option value="rgba(0,0,255,1)">蓝色</option>
                    </select>


                    <select @change="selectLineWidth($event)">
                        <option value=2>2</option>
                        <option value=5>5</option>
                        <option value=10>10</option>
                    </select>

                    <input type="button" value="撤销" @click="undo"/>
                    <input type="button" value="前进" @click="redo"/>
                    <input type="button" value="橡皮擦" @click="clearAnnotation"/>
                    <!--<input type="button" value="鼠标" onclick="chooseMouse()"  />-->
                    <input type="button" value="清除" @click="eraser"/>
                    <input type="button" value="下载" @click="download"/>
                    <!--<input type="button" value="激光笔" onclick="startHlightPoint()"  />-->
                </div>
                <div ref="whitebank" style="width: 100%;height: 100%;"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {videoDialogDragDirective} from "../../lib/directives/video-dialog-drag";
    import {bankDialogDragDirective} from "../../lib/directives/bank-dialog-drag"
    import {tee3bankmixin} from "../../lib/video/tee3bankmixin"
    export default {
        name: "consultation-bank-dialog",
        directives: {
            drag: videoDialogDragDirective,
            bank: bankDialogDragDirective
        },
        data(){
            return {
                showBank:false
            }
        },
        mixins:[tee3bankmixin],
        watch:{
            showBank(newVal){
                if(newVal){
                    //创建白板
                    this.$nextTick(() => {
                        this.createBank();
                    })
                }else{
                    //删除白板
                    this.$nextTick(() => {
                        this.removeBank();
                    })
                }
            }
        },
        methods:{
            show(){
                this.showBank = true;
            },
            selectChangeType(shapeType){
                let val = shapeType.target.value;
                if(val == '999'){
                    this.currentBoard.annotation.setShapeType(shapeTypeEnum.line);
                    this.currentBoard.annotation.setArrowType(arrowTypeEnum.double);
                }else if(val == '333'){
                    this.currentBoard.annotation.setShapeType(shapeTypeEnum.rect);
                    this.currentBoard.annotation.setFillColor(fillTypeEnum.full);
                }else{
                    this.currentBoard.annotation.setArrowType(arrowTypeEnum.none);
                    this.currentBoard.annotation.setShapeType(val);
                }
            },
            setColorOpacity(shapeType){
                let val = shapeType.target.value;
                this.currentBoard.annotation.setColorOpacity(val);
            },
            selectChangeColor(shapeType){
                let val = shapeType.target.value;
                this.currentBoard.annotation.setColor(val);
            },
            selectLineWidth(shapeType){
                let val = shapeType.target.value;
                this.currentBoard.annotation.setLineWidth(val);
            },
            undo(){
                this.currentBoard.annotation.undo();
            },
            redo(){
                this.currentBoard.annotation.redo();
            },
            clearAnnotation(){
                this.currentBoard.annotation.setShapeType(shapeTypeEnum.eraser,'./icon-eraser.png');
            },
            eraser(){
                this.currentBoard.annotation.clear();
            },
            download(){
                this.currentBoard.annotation.download();
            },
            hide(){
                this.showBank = false;
            }
        },
        created() {
            bus.$on('closeBank',this.hide);
        },
        destroyed() {
            bus.$off('closeBank');
        }

    }
</script>

<style scoped>
    .main {
        z-index: 1002;
    }
    .tag{
        width: 100%;
        height: 30px;
    }
</style>